// 업무상태에 대한 필터 함수를 정의한다.
export default (value) => {
  if (!value) return ''
  const statusArray = [
    { text: '예정', value: 1 },
    { text: '정산', value: 2 }
  ]
  return statusArray.find(s => s.value === value).text
}
